import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import { config } from '../Constants';
import helpers from '../Function';

import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';

import Checkbox from '@material-ui/core/Checkbox';
import $ from "jquery";
import ReactExport from "react-export-excel";
import { ExcelRenderer } from 'react-excel-renderer';
import { Button, Upload } from 'antd';
import {ValidateImageMatchSize} from '../utils/validateImage'

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export default class ProjectHome extends Component {

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
    }

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission, project_id } = authentication.currentUserValue;

        this.state = {
            PROJECTID: project_id,
            userid: user_id,
            user_permission: user_permission,
            pages: [],
            project_type_pages: [],
            addIsOpen: false,
            srcIsOpen: false,
            deleteIsOpen: false,
            updateIsOpen: false,
            warningIsOpen: false,
            content_id: '',
            warningMessage: "",
            methodOpen: '',
            jwt: jwt,
            add_id: '',
            add_name_th: '',
            add_name_en: '',
            add_project_type: '',
            project_type_name: '',
            add_house_number: '',
            add_moo: '',
            add_soi: '',
            add_road: '',
            add_subdistrict: '',
            add_district: '',
            add_province: '',
            add_central: '',
            add_postnumber: '',
            add_latitude: '',
            add_longtitude: '',
            add_active_status: '',
            // add_no: "0",
            add_img: '',
            active: true,
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            src_active: false,
            src_nonactive: false,
            src_central: '',
            file: null,
            page: 0,
            rowsPerPage: 10,
            miss_su: helpers.getUserType(user_type, "su"),
            pjid: '',

            // Take add import excel
            add_PROJECTID: '',
            rows: [],
            IsVerify: false,
            importIsOpen: false,
            import_no:'',
            import_project_nameth:'',
            import_project_nameen:'',
            import_project_id:'',
            import_line_kwanjai:'',
            import_project_brand:'',
            import_project_no:'',
            import_project_image:null,
            import_project_activestatus:'',
            import_juristic:'',
            import_house_number: '',
            import_moo: '',
            import_soi: '',
            import_road: '',
            import_subdistrict: '',
            import_district: '',
            import_province: '',
            import_central: '',
            import_postnumber: '',
            import_latitude: '',
            import_longtitude: '',

        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.closeAdd = this.closeAdd.bind(this);
        this.openAdd = this.openAdd.bind(this);
        this.submitAdd = this.submitAdd.bind(this);

        this.openEdit = this.openEdit.bind(this);
        this.openView = this.openView.bind(this);

        this.change = this.change.bind(this);
        this.dataTable = this.dataTable.bind(this);
        this.submitEdit = this.submitEdit.bind(this);

        this.closeSrc = this.closeSrc.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);

        this.handleCheck = this.handleCheck.bind(this)

        this.openDelete = this.openDelete.bind(this);
        this.closeDelete = this.closeDelete.bind(this);
        this.submitDelete = this.submitDelete.bind(this);

        this.onChange = this.onChange.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);

        this.closeModelUpdate = this.closeModelUpdate.bind(this);


        this.handleActiveSrcCheck = this.handleActiveSrcCheck.bind(this)
        this.handleNonActiveSrcCheck = this.handleNonActiveSrcCheck.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

        this.closeWarning = this.closeWarning.bind(this);

        
        this.fileHandler = this.fileHandler.bind(this);
        this.openImport = this.openImport.bind(this);
        this.closeImport = this.closeImport.bind(this);
        this.submitVerify = this.submitVerify.bind(this);
        this.submitImport = this.submitImport.bind(this);
        this.clearImportFiles = this.clearImportFiles.bind(this);
        this.initPJType = this.initPJType.bind(this);
        this.dataTable();
        this.initPJType();

    }

    initPJType() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
            const query = '?dropdown=1'
            fetch(config.url.API_URL + '/project_types/' + query, requestOptions)
                .then(res => res.json())
                .then(data => {
                    const reponse = data.data

                    const FromApi = []
                    if(reponse.length > 0){
                        reponse.map(datas => {
                            return FromApi.push( { value: datas.id, display: datas.name_th })
                        });
                    }
    
                    this.setState({
                        project_type_pages: [{ value: '', display: 'เลือกแบรนด์' }].concat(FromApi)
                    });
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    dataTable() {
        try {
            let project_id = ``
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            if (this.state.PROJECTID) {
                project_id = this.state.PROJECTID
            } else {
                project_id = ``
            }
    
            let body = `?projecthomeid=${project_id}&pjid=${this.state.pjid}`
    
            fetch(config.url.API_URL + '/project_homes' + body, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var data = dataMain.data
                    this.setState({
                        pages: [].concat(data)
                    });
                }).catch(error => {
                    console.log(error)
                    // //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            // //window.location.reload(); // Reload the page
        }
    }

    openImport() {
        // document.getElementById('submitImport').disabled = true
        this.setState({
            importIsOpen: true,
            rows: [],
            errorMessage: null,
            IsVerify: false
        });
    }
    closeImport() {
        this.setState({
            importIsOpen: false,
        });
    }

    clearImportFiles(){
        document.getElementById('importexcel').disabled = false
        document.getElementById('importexcelfile').disabled = false
        this.setState({ rows: [] }) 
    }
submitVerify = async () => {
    try {
        if (this.state.rows.length < 1) {
            alert('ไม่มีข้อมูลการ import')
            return
        }
    
        const requestOptions = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            }
        };
    
        const batchSize = 10;
        const failedArr = []
        const successArr = []
        let verify_failed = 0
        let verify_success = 0
    
        this.setState({spinner:true})
        for (let i = 0; i < this.state.rows.length; i += batchSize) {
            const batch = this.state.rows.slice(i, i + batchSize);
            const data = batch.map((item) => ({ ...item }));
    
            requestOptions.body = JSON.stringify({
                import_data: data,
                createby: this.state.create_by,
                createby_id: this.state.create_by_id
            });
    
            try {
                const res = await fetch(config.url.API_URL + '/verify_import_projecthome', requestOptions);
                const data = await res.json();
                console.log(data.status)
                if (data.status === "Success") {
                    const result = data.data
    
                    successArr.push(...result.success)
                    failedArr.push(...result.failed)
                    data.error > 0 ? verify_failed++ : verify_success++;
    
                } else {
                    this.setState({
                        errorMessage: null,
                        IsVerify: false,
                    });
                }
            } catch (err) {
                console.log(err)
                this.setState({
                    rows: [],
                    errorMessage: 'error cannot import',
                    IsVerify: false,
                    spinner:false
                });
            }
        }
        const resultArr = [...failedArr,...successArr]
        this.setState({
            rows: resultArr,
            errorMessage: null,
            IsVerify: true,
            spinner: false
        });
        verify_failed > 0 ? document.getElementById('submitImport').disabled = true : document.getElementById('submitImport').disabled = false;
    } catch (error) {
        console.log(error)
        //window.location.reload(); // Reload the page
    }
}

    
submitImport() {
    try {
        if (this.state.rows.length < 1) {
            alert('ไม่มีข้อมูลการ import')
            return
        }
    
        if (!this.state.IsVerify) {
            alert('กรุณาตรวจสอบข้อมูล')
            return
        }
    
        const batchSize = 10;
        const requestOptions = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.state.jwt,
            }
        };
    
        const importBatch = async (start) => {
            if (start >= this.state.rows.length) {
                this.setState({
                    importIsOpen: false,
                    updateIsOpen: true,
                    spinner: false
                });
                return;
            }
    
            const batch = this.state.rows.slice(start, start + batchSize);
            requestOptions.body = JSON.stringify({
                import_data: batch,
                createby: this.state.create_by,
                createby_id: this.state.create_by_id
            });
    
            try {
                const res = await fetch(config.url.API_URL + '/import_projecthome', requestOptions);
                const data = await res.json();
            } catch (err) {
                console.log(`error during import`)
                console.log(err)
                this.setState({
                    spinner: false,
                    updateIsOpen: false
                })
            }
    
            // Process next batch
            importBatch(start + batchSize);
        }
    
        // Start importing batches
        importBatch(0);
    } catch (error) {
        console.log(error)
    }
}

    fileHandler = fileList => {
        console.log('fileList', fileList);
        let fileObj = fileList;
        if (!fileObj) {
            this.setState({
                errorMessage: 'No file uploaded!'
            });
            return false;
        }
        console.log('fileObj.type:', fileObj.type);
        if (
            !(
                fileObj.type === 'application/vnd.ms-excel' ||
                fileObj.type ===
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            )
        ) {
            this.setState({
                errorMessage: 'Unknown file format. Only Excel files are uploaded!'
            });
            return false;
        }
        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            if (err) {
                console.log(err);
            } else {
                document.getElementById('importexcel').disabled = true
                document.getElementById('importexcelfile').disabled = true
                let newRows = [];
                console.log("resp",resp)
                resp.rows.slice(1).map((row, index) => {
                    if (row.length > 0) {
                        newRows.push({
                            key: index,
                            import_no: row[0],
                            import_project_nameth:row[1],
                            import_project_nameen:row[2],
                            import_project_id:row[3],
                            import_line_kwanjai:row[4],
                            import_project_brand:row[5],
                            import_project_no:row[6],
                            is_mgm: row[7], //add check
                            import_juristic: row[8],
                            is_projectdetail: row[9], //add check
                            import_house_number:row[10],
                            import_moo:row[11],
                            import_soi:row[12],
                            import_road:row[13],
                            import_subdistrict:row[14],
                            import_district:row[15],
                            import_province:row[16],
                            import_postnumber:row[17],
                            import_latitude:row[18],
                            import_longtitude:row[19],
                            import_comment:row[20],
                            // import_project_image: null,
                            import_project_activestatus: 1,
                        });
                    }
                }, {});
                if (newRows.length === 0) {
                    this.setState({
                        errorMessage: 'No data found in file!'
                    });
                    return false;
                } else {
                    this.setState({
                        rows: newRows,
                        errorMessage: null
                    });

                    console.log(this.state.rows)
                }
            }
        });
        return false;
    };

    resetFormState() {
        this.setState({
            src_central: '',
            src_active: false,
            src_nonactive: false,
            add_id: '',
            add_project_type: '',
            add_name_th: '',
            add_name_en: '',
            add_house_number: '',
            add_moo: '',
            add_soi: '',
            add_road: '',
            add_subdistrict: '',
            add_district: '',
            add_province: '',
            add_central: '',
            add_postnumber: '',
            add_latitude: '',
            add_longtitude: '',
            add_active_status: '',
            previewImage: null,
            // add_no: '',
            add_img: '',
            add_name: '',
            active: true
        })
    }

    dataTableSrc() {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            let body = `?pjid=${this.state.pjid}&active=${this.state.src_active}&nonactive=${this.state.src_nonactive}&name_th=${this.state.add_name_th}&name_en=${this.state.add_name_en}&project_type_id=${this.state.add_project_type}&central=${this.state.src_central}`
    
            fetch(config.url.API_URL + '/project_homesSrc' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data.data) && data.data.length) {
                        this.setState({
                            pages: [].concat(data.data)
                        });
    
                    } else {
                        this.setState({
                            pages: []
                        });
                    }
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitSrc(e) {
        this.dataTableSrc()
        this.setState({ srcIsOpen: false });
    }

    openAdd() {
        this.setState({
            addIsOpen: true,
            methodOpen: 'add',
            add_id: '',
            add_name_th: '',
            add_name_en: '',
            add_project_type: '',
            project_type_name: '',
            add_house_number: '',
            add_moo: '',
            add_soi: '',
            add_road: '',
            add_subdistrict: '',
            add_district: '',
            add_province: '',
            add_postnumber: '',
            add_latitude: '',
            add_longtitude: '',
            add_central: ""
        });
    }

    openEdit(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/project_homes/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var [data] = dataMain.data;
                    this.setState({
                        add_id: data.id,
                        add_name_th: data.name_th,
                        add_name_en: data.name_en,
                        add_project_type: data.project_type,
                        add_house_number: data.house_number,
                        add_moo: data.moo,
                        add_soi: data.soi,
                        add_road: data.road,
                        add_subdistrict: data.sub_district,
                        add_district: data.district,
                        add_province: data.province,
                        add_postnumber: data.post_number,
                        add_latitude: data.latitude,
                        add_longtitude: data.longtitude,
                        add_central: data.central_flag == undefined ? "" : data.central_flag,
                        active: data.active,
                        add_PROJECTID: data.PROJECTID,
                        previewImage: data.img,
                        add_no: data.no == undefined ? "" : data.no
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'edit'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openView(e) {
        try {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/project_homes/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataMain => {
                    var [data] = dataMain.data;
                    console.log(data)
                    this.setState({
                        add_id: data.id,
                        add_name_th: data.name_th,
                        add_name_en: data.name_en,
                        add_project_type: data.project_type_id,
                        project_type_name: data.project_type_name,
                        add_house_number: data.house_number,
                        add_moo: data.moo,
                        add_soi: data.soi,
                        add_road: data.road,
                        add_subdistrict: data.sub_district,
                        add_district: data.district,
                        add_province: data.province,
                        add_postnumber: data.post_number,
                        add_latitude: data.latitude,
                        add_longtitude: data.longtitude,
                        add_img: data.img,
                        add_active_status: data.active_status,
                        add_central: data.central_flag,
                        add_PROJECTID: data.PROJECTID,
                        add_no: data.no,
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'view'
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    closeDelete() {
        this.setState({ deleteIsOpen: false });
        this.dataTable();
    }

    closeWarning() {
        this.setState({ warningIsOpen: false });
        this.dataTable();
    }

    closeAdd() {
        this.setState({
            add_id: '',
            add_name: '',
            add_name_en: '',
            previewImage: null
        });
        this.setState({ addIsOpen: false });
    }

    closeSrc() {
        this.resetFormState()
        this.setState({ srcIsOpen: false });
    }

    closeModelUpdate() {
        this.resetFormState()
        this.setState({ updateIsOpen: false ,previewImage:null});
        this.dataTable();
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_active: false,
            src_nonactive: false,
            src_central: '',
            add_name_th: '',
            add_name_en: '',
            add_project_type: '',
            page: 0
        });
    }

    submitAdd() {
        try {
            if (!this.state.add_name_th) {
                alert('ไม่พบข้อมูลชื่อไทย');
                return;
            }
    
            if (!this.state.add_name_en) {
                alert('ไม่พบข้อมูลชื่ออังกฤษ');
                return;
            }
    
            if (!this.state.add_project_type) {
                alert('ไม่พบข้อมูลแบรนด์');
                return;
            }
    
            if (!this.state.file) {
                alert('ไม่พบข้อมูลรูปโลโก้แบรนด์');
                return;
            }
    
            if (!this.state.add_central) {
                alert('ไม่พบข้อมูลบริหารหมู่บ้าน');
                return;
            }
    
            if (!this.state.add_house_number) {
                alert('ไม่พบข้อมูลบ้านเลขที่');
                return;
            }
    
            if (!this.state.add_subdistrict) {
                alert('ไม่พบข้อมูลตำบล');
                return;
            }
    
            if (!this.state.add_district) {
                alert('ไม่พบข้อมูลอำเภอ');
                return;
            }
    
            if (!this.state.add_province) {
                alert('ไม่พบข้อมูลจังหวัด');
                return;
            }
    
            if (!this.state.add_postnumber) {
                alert('ไม่พบข้อมูลรหัสไปรษณีย์');
                return;
            }
    
            if (!this.state.add_PROJECTID) {
                alert('ไม่พบข้อมูล Project ID');
                return;
            }
    
            const formData = new FormData();
            formData.append('name_th', this.state.add_name_th);
            formData.append('name_en', this.state.add_name_en);
            formData.append('central_flag', this.state.add_central);
            formData.append('project_type_id', this.state.add_project_type);
            formData.append('house_number', this.state.add_house_number);
            formData.append('moo', this.state.add_moo);
            formData.append('soi', this.state.add_soi);
            formData.append('road', this.state.add_road);
            formData.append('sub_district', this.state.add_subdistrict);
            formData.append('district', this.state.add_district);
            formData.append('province', this.state.add_province);
            formData.append('post_number', this.state.add_postnumber);
            formData.append('latitude', this.state.add_latitude);
            formData.append('longtitude', this.state.add_longtitude);
            formData.append('PROJECTID', this.state.add_PROJECTID);
            formData.append('no', this.state.add_no);
            formData.append('createby', this.state.create_by);
            formData.append('createby_id', this.state.create_by_id);
            formData.append('myImage', this.state.file);
            formData.append('active_status', this.state.active ? 1 : 0);
    
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': this.state.jwt,
                },
                body: formData
            };
    
            fetch(config.url.API_URL + '/project_homes', requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (data.data.message) {
                        this.setState({
                            updateIsOpen: false,
                            warningIsOpen: true,
                            warningMessage: data.data.message
                        });
                    } else {
                        this.setState({
                            updateIsOpen: true
                        });
                    }
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
    
            this.setState({ addIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitDelete(e) {
        try {
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/delete_project_homes/' + this.state.content_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
    
            this.setState({ deleteIsOpen: false });
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    openDelete(e) {
        this.setState({
            deleteIsOpen: true,
            content_id: e.currentTarget.attributes["data-id"].value
        });
    }

    submitEdit(e) {
        try {
            if (!this.state.add_name_th) {
                alert('ไม่พบข้อมูลชื่อไทย');
                return;
            }
    
            if (!this.state.add_name_en) {
                alert('ไม่พบข้อมูลชื่ออังกฤษ');
                return;
            }
    
            if (!this.state.add_project_type) {
                alert('ไม่พบข้อมูลแบรนด์');
                return;
            }
    
            // if (!this.state.file) {
            //     alert('ไม่พบข้อมูลรูปโลโก้แบรนด์');
            //     return;
            // }
    
            if (!this.state.add_central) {
                alert('ไม่พบข้อมูลบริหารหมู่บ้าน');
                return;
            }
    
            if (!this.state.add_house_number) {
                alert('ไม่พบข้อมูลบ้านเลขที่');
                return;
            }
    
            if (!this.state.add_subdistrict) {
                alert('ไม่พบข้อมูลตำบล');
                return;
            }
    
            if (!this.state.add_district) {
                alert('ไม่พบข้อมูลอำเภอ');
                return;
            }
    
            if (!this.state.add_province) {
                alert('ไม่พบข้อมูลจังหวัด');
                return;
            }
    
            if (!this.state.add_postnumber) {
                alert('ไม่พบข้อมูลรหัสไปรษณีย์');
                return;
            }
    
            if (!this.state.add_PROJECTID) {
                alert('ไม่พบข้อมูล Project ID');
                return;
            }
            const formData = new FormData();
            formData.append('name_th', this.state.add_name_th);
            formData.append('name_en', this.state.add_name_en);
            formData.append('central_flag', this.state.add_central);
            formData.append('project_type_id', this.state.add_project_type);
            formData.append('house_number', this.state.add_house_number);
            formData.append('moo', this.state.add_moo);
            formData.append('soi', this.state.add_soi);
            formData.append('road', this.state.add_road);
            formData.append('sub_district', this.state.add_subdistrict);
            formData.append('district', this.state.add_district);
            formData.append('province', this.state.add_province);
            formData.append('post_number', this.state.add_postnumber);
            formData.append('latitude', this.state.add_latitude);
            formData.append('longtitude', this.state.add_longtitude);
            formData.append('updateby', this.state.create_by);
            formData.append('updateby_id', this.state.create_by_id);
            formData.append('PROJECTID', this.state.add_PROJECTID);
            formData.append('no', this.state.add_no);
            formData.append('myImage', this.state.file);
            formData.append('active_status', this.state.active ? 1 : 0);
    
    
            const requestOptions = {
                method: 'PUT',
                headers: {
                    'Authorization': this.state.jwt,
                },
                body: formData
            };
            fetch(config.url.API_URL + '/project_homes/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        addIsOpen: false
                    });
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleCheck() {
        this.setState({ active: !this.state.active });
    }

    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    onChange(e) {
        this.setState({ file: e.target.files[0] })

        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onloadend = () => {
            this.setState({ previewImage: reader.result });
          };
          reader.readAsDataURL(file);
        }else{
            this.setState({previewImage:null,file:null})
        }

        // const fileName = e.target.files[0]
        // const validateOption = {
        //     width: 1120,
        //     height: 720,
        // }

        // ValidateImageMatchSize(fileName, validateOption)
        //     .then(() => this.setState({ file: fileName }))
        //     .catch(err => {
        //         document.getElementsByName('myImage')[0].value = null
        //         alert(err)
        //     })
    }

    handleActiveSrcCheck() {
        this.setState({
            src_active: !this.state.src_active
        });
    }

    handleNonActiveSrcCheck() {
        this.setState({
            src_nonactive: !this.state.src_nonactive
        });
    }

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    render() {
        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Project Home List</h1>
                            </div>{/* /.col */}
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">project Home</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}
                {/* Main content */}
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    <ExcelFile filename="project_home" element={(this.state.user_permission[227].permission == 1 &&
                                        <div className="btn-add text-center">Export Data</div>
                                    )}>
                                        <ExcelSheet data={this.state.pages} name="project_home">
                                            <ExcelColumn label="PROJECTID" value={(col) => col.PROJECTID} />
                                            <ExcelColumn label="ชื่อไทย" value={(col) => col.name_th} />
                                            <ExcelColumn label="ชื่ออังกฤษ" value={(col) => col.name_en} />
                                            <ExcelColumn label="แบรนด์" value={(col) => col.project_type_name} />
                                            <ExcelColumn label="ที่อยู่" value={(col) => col.address} />
                                            <ExcelColumn label="อัพเดทล่าสุด" value={(col) => col.updateby} />
                                            <ExcelColumn label="อัพเดทล่าสุด(วันที่)" value={(col) => col.updated} />
                                        </ExcelSheet>
                                    </ExcelFile>
                                    {(this.state.user_permission[224].permission == 1 &&
                                        <div className="btn-add text-center" ><a href={`${config.url.API_URL}/downloadFile/projecthome_template.xlsx`} style={{ color: 'black' }}>Download Template</a></div>
                                    )}
                                    {(this.state.user_permission[213].permission == 1 &&
                                        <div className='btn-add text-center' onClick={this.openImport}>Import</div>
                                    )}
                                    {(this.state.user_permission[32].permission == 1 &&
                                        <div className="btn-add text-center" onClick={this.openAdd}>เพิ่มข้อมูล</div>
                                    )}
                                </div>
                                {/* .card-header */}
                                <div className="card-body">
                                    {
                                        this.state.spinner && <div style={{ textAlign: 'center' }}><CircularProgress /></div>
                                    }
                                    {
                                        !this.state.spinner && 
                                    <TableContainer component={Paper}>

                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: 'auto' }}>No</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>Project ID</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>แบรนด์</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่อไทย</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่ออังกฤษ</StyledTableCell>
                                                    {/* <StyledTableCell style={{ width: 'auto' }}>ที่อยู่</StyledTableCell> */}
                                                    <StyledTableCell style={{ width: 'auto' }}>วันที่สร้าง</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>สถานะ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>อัพเดทล่าสุด</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>รายละเอียด</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    <StyledTableCell className='text-center'>{data.num}</StyledTableCell>
                                                                    <StyledTableCell className='text-center'>{data.PROJECTID}</StyledTableCell>
                                                                    <StyledTableCell>{data.project_type_name}</StyledTableCell>
                                                                    <StyledTableCell>{data.name_th}</StyledTableCell>
                                                                    <StyledTableCell>{data.name_en}</StyledTableCell>
                                                                    {/* <StyledTableCell>{data.address}</StyledTableCell> */}
                                                                    <StyledTableCell>{data.create}</StyledTableCell>
                                                                    <StyledTableCell>{data.active_status}</StyledTableCell>
                                                                    {data.updateby != undefined && <StyledTableCell>{data.updateby}<br />{data.updateby == undefined ? data.updated : data.updated}</StyledTableCell>}
                                                                    {data.updateby == undefined && <StyledTableCell>{data.updated}</StyledTableCell>}
                                                                    <StyledTableCell>
                                                                        <button className="btn-action text-center" data-id={data.id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" />View</button>

                                                                        {(this.state.user_permission[33].permission == 1 &&
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openEdit}><img src="dist/img/icon/ic_update.png" className="btn-icon" alt="" /> Update</button>
                                                                        )}
                                                                        {(this.state.user_permission[34].permission == 1 &&
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openDelete}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>
                                                                        )}
                                                                    </StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                    }
                                </div>
                                {/* /.card-body */}
                            </div>
                            {/* /.card */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </section>
                {/* /.content */}
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่อไทย</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="add_name_th" name="add_name_th" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">PROJECT ID</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="pjid" name="pjid" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ชื่ออังกฤษ</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="add_name_en" name="add_name_en" onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">แบรนด์</div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="add_project_type" onChange={this.change}>
                                        {this.state.project_type_pages.map((datas, index) => <option key={index} value={datas.value} selected={this.state.add_project_type === datas.value && "selected"}>{datas.display}</option>)}
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">บริหารหมู่บ้าน</div>
                                <div className="col-sm-5">
                                    <select className="form-control" name="src_central" onChange={this.change}>
                                        <option value="">เลือกประเภทบริหารหมู่บ้าน</option>
                                        <option value="1" >มีบริหารหมู่บ้าน (แสดงเมนูนิติบุคคล)</option>
                                        <option value="0" >ไม่มีบริหารหมู่บ้าน (ไม่แสดงเมนูนิติบุคคล)</option>
                                    </select>
                                </div>
                            </div>
                            <div className="row mb-3" >
                                <div className="col-sm-3 text-right">สถานะ</div>
                                <div className="col-sm-5">
                                    <Checkbox
                                        checked={this.state.src_active}
                                        onChange={this.handleActiveSrcCheck}
                                        color="primary"
                                    /> ใช้งาน
                                    <Checkbox
                                        checked={this.state.src_nonactive}
                                        onChange={this.handleNonActiveSrcCheck}
                                        color="primary"
                                    /> ไม่ได้ใช้งาน
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl">
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'add' && "เพิ่มข้อมูล") || (this.state.methodOpen === 'edit' && "แก้ไขข้อมูล") || (this.state.methodOpen === 'view' && "ตรวจสอบข้อมูล")}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">ชื่อไทย<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_name_th" name="add_name_th" defaultValue={this.state.add_name_th} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_name_th}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">ตำบล/แขวง<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_subdistrict" name="add_subdistrict" defaultValue={this.state.add_subdistrict} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_subdistrict}</div>)}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">ชื่ออังกฤษ<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_name_en" name="add_name_en" defaultValue={this.state.add_name_en} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_name_en}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">อำเภอ/เขต<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_district" name="add_district" defaultValue={this.state.add_district} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_district}</div>)}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right" >แบรนด์<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<select className="form-control" name="add_project_type" onChange={this.change}>
                                            {this.state.project_type_pages.map((datas) => <option value={datas.value} selected={this.state.add_project_type === datas.value && "selected"}>{datas.display}</option>)}
                                        </select>) : (<div className="form-control">{this.state.project_type_name}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">จังหวัด<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_province" name="add_province" defaultValue={this.state.add_province} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_province}</div>)}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">บ้านเลขที่<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_house_number" name="add_house_number" defaultValue={this.state.add_house_number} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_house_number}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">รหัสไปรษณีย์<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_postnumber" name="add_postnumber" defaultValue={this.state.add_postnumber} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_postnumber}</div>)}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">หมู่ :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_moo" name="add_moo" defaultValue={this.state.add_moo} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_moo}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">Latitude :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_latitude" name="add_latitude" defaultValue={this.state.add_latitude} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_latitude}</div>)}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">ซอย :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_soi" name="add_soi" defaultValue={this.state.add_soi} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_soi}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">Longtitude :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_longtitude" name="add_longtitude" defaultValue={this.state.add_longtitude} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_longtitude}</div>)}
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">ถนน :</div>
                                <div className="col-sm-4">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_road" name="add_road" defaultValue={this.state.add_road} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_road}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">บริหารหมู่บ้าน<span style={{ color: 'red' }}>*</span> :</div>
                                <div className="col-sm-3">
                                    {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<select className="form-control" name="add_central" onChange={this.change}>
                                            <option value="">เลือกประเภทบริหารหมู่บ้าน</option>
                                            <option value="1" selected={this.state.add_central === 1 && "selected"}>มีบริหารหมู่บ้าน (แสดงเมนูนิติบุคคล)</option>
                                            <option value="0" selected={this.state.add_central === 0 && "selected"}>ไม่มีบริหารหมู่บ้าน (ไม่แสดงเมนูนิติบุคคล)</option>
                                        </select>)
                                        : (<select className="form-control" name="add_central" onChange={this.change} disabled>
                                            <option value="0">เลือกประเภทบริหารหมู่บ้าน</option>
                                            <option value="1" selected={this.state.add_central === 1 && "selected"}>มีบริหารหมู่บ้าน (แสดงเมนูนิติบุคคล)</option>
                                            <option value="0" selected={this.state.add_central === 0 && "selected"}>ไม่มีบริหารหมู่บ้าน (ไม่แสดงเมนูนิติบุคคล)</option>
                                        </select>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                            <div className="col-sm-2 text-right">Project ID<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-4">
                                {this.state.methodOpen === 'add' || this.state.methodOpen === 'edit' ?
                                        (<input type="text" className="form-control" id="add_PROJECTID" name="add_PROJECTID" defaultValue={this.state.add_PROJECTID} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_PROJECTID}</div>)}
                                </div>
                                <div className="col-sm-2 text-right">โลโก้แบรนด์<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-4">
                                {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ? (
                                    <>
                                        {this.state.previewImage && (
                                        <div>
                                            <img src={this.state.previewImage} alt="preview" width="250" height="auto" style={{ObjectFit:'cover'}} />
                                        </div>
                                        )}
                                        <div>
                                            <input type="file" name="myImage" onChange={this.onChange} accept="image/png, image/jpeg" />
                                        </div>

                                    </>
                                    ) : (
                                        <>
                                        {this.state.add_img && (<img src={this.state.add_img} alt="pic" width="250" height="auto" style={{ObjectFit:'cover'}}/>)}
                                        </>                                    
                                )}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">ลำดับ :</div>
                                <div className="col-sm-4">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_no" name="add_no" defaultValue={this.state.add_no} onChange={this.change} 
                                        onKeyPress={(event) => {
                                            const keyCode = event.which ? event.which : event.keyCode;
                                            const keyValue = String.fromCharCode(keyCode);
                                            if (!/^\d+$/.test(keyValue)) {
                                              event.preventDefault();
                                            }
                                          }}
                                        />)
                                        : (<div className="form-control">{this.state.add_no}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className='col-sm-6'></div>
                                <div className="col-sm-5 text-right"><span style={{ color: 'rgb(247, 188, 11)', fontSize: '18px' }}>*หมายเหตุ : แนะนำไฟล์ JPG, PNG ขนาด 1120 * 720px</span></div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-sm-2 text-right">สถานะ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<p><Checkbox
                                            checked={this.state.active}
                                            onChange={this.handleCheck}
                                            color="primary"
                                        />ใช้งาน</p>)
                                        : (<div>
                                            <p>{this.state.add_active_status}</p>
                                        </div>)}
                                </div>
                            </div>

                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {(this.state.methodOpen === 'add' &&
                            (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                <button className="btn btn-success" onClick={this.submitAdd}>เพิ่มข้อมูล</button></div>))
                            || (this.state.methodOpen === 'edit' &&
                                (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button></div>))
                            || (this.state.methodOpen === 'view' &&
                                (<div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>))}
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                        </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.deleteIsOpen} onHide={this.closeDelete} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการลบรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDelete}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-warning" onClick={this.submitDelete}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.warningIsOpen} onHide={this.closeWarning} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        {this.state.warningMessage}
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeWarning}>ยกเลิก</button>
                    </ModalFooter>
                </Modal>

                <Modal show={this.state.importIsOpen} onHide={this.closeImport} size='xl'>
                    <ModalHeader>
                        <div className='row'>
                            <div className='col-sm-12'>
                                <Upload id='importexcelfile' name='file' beforeUpload={this.fileHandler} onRemove={this.clearImportFiles} multiple={false} accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel' >
                                    <Button id='importexcel' className='btn btn-primary'> Import Excel File </Button>
                                </Upload>
                            </div>
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        <form id='form-submit'>
                            <div className='row mb-3'>
                                <div className='col-sm-12'>
                                    <TableContainer component={Paper}>
                                        <Table aria-label='simple table'>
                                            <TableHead>
                                                <TableRow>
                                                {
                                                    this.state.IsVerify && <StyledTableCell style={{ width: 'auto' }}>หมายเหตุ</StyledTableCell> 
                                                }
                                                    <StyledTableCell style={{ width: 'auto' }}>No</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่อไทย</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ชื่ออังกฤษ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ProjectID</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>Line Kwanjai</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ประเภทแบรนด์ (Brand)</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ลำดับ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>สถานะ</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>บริหารหมู่บ้าน</StyledTableCell>
                                                    {/* <StyledTableCell style={{ width: 'auto' }}>บ้านเลขที่</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>หมู่</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ซอย</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ถนน</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ตำบล/แขวง</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>อำเภอ/เขต</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>จังหวัด</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>รหัสไปรษณีย์</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>Latitude</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>Longtitude</StyledTableCell> */}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.rows.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    {
                                                                        this.state.IsVerify && <StyledTableCell style={data.import_comment == 'Create' || data.import_comment == 'Update' ? { color: 'rgb(106 182 170)' } : {color: 'rgb(250, 108, 108)'}}>{data.import_comment}</StyledTableCell> 
                                                                    }
                                                                    <StyledTableCell>{data.import_no}</StyledTableCell>
                                                                    <StyledTableCell>{data.import_project_nameth}</StyledTableCell>
                                                                    <StyledTableCell>{data.import_project_nameen}</StyledTableCell>
                                                                    <StyledTableCell>{data.import_project_id}</StyledTableCell> 
                                                                    <StyledTableCell>{data.import_line_kwanjai}</StyledTableCell> 
                                                                    <StyledTableCell>{data.import_project_brand}</StyledTableCell> 
                                                                    <StyledTableCell>{data.import_project_no}</StyledTableCell> 
                                                                    <StyledTableCell>{data.import_project_activestatus}</StyledTableCell> 
                                                                    <StyledTableCell>{data.import_juristic}</StyledTableCell> 
                                                                    {/* <StyledTableCell>{data.import_house_number}</StyledTableCell> 
                                                                    <StyledTableCell>{data.import_moo}</StyledTableCell> 
                                                                    <StyledTableCell>{data.import_soi}</StyledTableCell> 
                                                                    <StyledTableCell>{data.import_road}</StyledTableCell> 
                                                                    <StyledTableCell>{data.import_subdistrict}</StyledTableCell> 
                                                                    <StyledTableCell>{data.import_district}</StyledTableCell> 
                                                                    <StyledTableCell>{data.import_province}</StyledTableCell> 
                                                                    <StyledTableCell>{data.import_postnumber}</StyledTableCell> 
                                                                    <StyledTableCell>{data.import_latitude}</StyledTableCell> 
                                                                    <StyledTableCell>{data.import_longtitude}</StyledTableCell>  */}
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component='div'
                                            count={this.state.rows.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <div className='row'>
                            <button className='btn btn-warning' onClick={this.submitVerify}>ตรวจสอบข้อมูล</button>
                        &nbsp;&nbsp;
                            <button className='btn btn-danger' onClick={this.closeImport}>ยกเลิก</button>
                        &nbsp;&nbsp;
                            <button id='submitImport' className='btn btn-success' data-id={this.state.add_id} onClick={this.submitImport}>ตกลง</button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}